/* globals angular */
angular.module('bzMessageBannerModule', [])
